import $ from 'jquery';
import _ from 'lodash';
import {View} from 'backbone';
import Moment from 'moment';
import Spinner              from 'spin/spin';
import eventBus  from 'EventBus.js';
import BaseDashboardLeftPanelView from 'dashboard/BaseDashboardLeftPanelView.js';
import NotificationDetailsView from 'dashboard/notifications/NotificationDetailsView.js';
import NotificationMainView from 'dashboard/notifications/NotificationsDetailView.js';
import RestService from 'RestService';
import listService          from 'ListService.js';
import util from 'util/Util.js';
import NotificationService from 'NotificationService.js';
import NotificationDetailsModel from 'NotificationDetailsModel.js';
import DashboardNotificationsModel from 'DashboardNotificationsModel.js';
import NotificationsFailedView from 'dashboard/notifications/NotificationsFailedView.js'

import constants        from 'Constants.js';
import NotificationsAttentionView from "./NotificationsAttentionView";

const ICON_FOLDER = constants.DB_ICON_FOLDER;
const ICON_EMPTY = constants.DB_ICON_EMPTY;

class NotificationsLeftPanelView extends BaseDashboardLeftPanelView {

    initialize(opts) {
        super.initialize(opts);

        this.options = opts || {};

        this.sections = {
            ATTENTION_NEEDED: 'AttentionNeeded',
            NO_ATTENTION_NEEDED: 'NoAttentionNeeded',
            FAILED_NOTIFICATIONS:'FailedNotifications'
        };

        // PF-3036 Commenting as it is overwriting the current events being set on the parent.
        // this.events= {
        //     'click .document-title': 'handleSection'
        // };
        // structure to load List
        var sections = {
            sections: [
                {
                    sectionName: 'Attention Needed',
                    sectionType: 'sectionAttentionNeeded',
                    groupType: 'attentionNeeded',
                    id: constants.NOTIFICATION_VIEW_GROUP_TYPE,
                    nodeType: 'attentionNeeded',
                    nodes: []
                },
                {
                    sectionName: 'No Attention Needed',
                    sectionType: 'sectionNoAttentionNeeded',
                    groupType: 'noAttentionNeeded',
                    id: constants.NOTIFICATION_VIEW_GROUP_TYPE,
                    nodeType: 'noAttentionNeeded',
                    nodes: []
                },
                {
                    sectionName: 'Failed Notifications',
                    sectionType: 'sectionFailedNotifications',
                    groupType: 'failedNotifications',
                    id: constants.NOTIFICATION_VIEW_GROUP_TYPE,
                    nodeType: 'failedNotifications',
                    nodes: [],
                    groups: []
                }
            ]
        };


        this.model.set('notificationSections', sections, {silent: true});
        this.model.set('currentActiveSection', 'notificationSections', {silent: true});

        this.listenTo(eventBus, 'loadViewNotification', this.renderNotificationDetails);
        this.listenTo(eventBus, constants.EV_RELOAD_FAILED_NOTIFICATIONS, this.renderNotificationDashboard);
        this.listenTo(eventBus, constants.EV_SHOW_NOTIFICATION_DETAILS, this.renderNotificationDetails);
        this.listenTo(eventBus, constants.EV_SHOW_ATTENTION_NOTIFICATION_DASHBOARD, this.renderAttentionNotificationDashboard);
        this.listenTo(eventBus, constants.EV_REFRESH_ATTENTION_NEEDED_NOTIFICATIONS_DASHBOARD_AND_NODES, this.renderNotificationDashboardAndNodes);
        this.listenTo(eventBus, constants.EV_REFRESH_NO_ATTENTION_NEEDED_NOTIFICATIONS_DASHBOARD_AND_NODES, this.renderNotificationDashboardAndNodes);
        this.listenTo(eventBus, constants.EV_REFRESH_FAILED_NOTIFICATIONS_DASHBOARD, this.renderFailedNotificationDashboard);
        this.listenTo(eventBus, constants.EV_REFRESH_NOTIFICATIONS_MAIN_VIEW_DETAILS, this.refreshNotificationsMainView);

        return this;
    }

    handleExpand(ev) {
        try {
            ev.preventDefault();
            this.attachRightClickMenu();
            this.contextMenus && typeof this.contextMenus.close === 'function' && this.contextMenus.close();
        } catch (e) {

        }

        if (listService.avoidDoubleClickOnDashboardTree) {
            return;
        }

        listService.avoidDoubleClickOnDashboardTree = true;

        let itemId = ev.currentTarget.attributes['data-itemid'].value;
        let groupType = ev.currentTarget.attributes['data-groupType'].value;
        let nodeType = ev.currentTarget.attributes['data-nodeType'].value;

        // don't process on the collapse
        if (new RegExp('collapsed').test(ev.currentTarget.className)) {
            const _none = () => {
                this.collapseWithoutPropagation(ev);
            };

            const getNotifications = () => {
                let dataTarget = ev.currentTarget.attributes['data-target'].value;
                itemId = itemId !== constants.NOTIFICATION_VIEW_GROUP_TYPE ? itemId : constants.DEFAULT_GROUP_ID;
                let currentTargetObj = $(ev.currentTarget);

                if (currentTargetObj.hasClass('document-heading')) {
                    util.togglePanel(currentTargetObj.find('.switch'), currentTargetObj.find('i'));
                }
                else {
                    //In this case the target is the same as the icon
                    util.togglePanel(currentTargetObj, currentTargetObj);
                }

                RestService.getNotifications(groupType === 'attentionNeeded').then((data) => {
                    let notifications;
                    if (data.NotificationList) {
                        notifications = data.NotificationList.Notification instanceof Array ?
                            data.NotificationList.Notification : [data.NotificationList.Notification];
                    }

                    let nodes = [];
                    if (notifications) {
                        nodes = this.loadNodesFromResponse(notifications, groupType);
                    } else {
                        nodes = [{
                            nodeName: 'no items',
                            url: '#',
                            icon: ICON_EMPTY,
                            id: 0,
                            groupType: groupType,
                            nodeType: '',
                            hasChildren: false
                        }]
                    }
                    // Attention Needed
                    if(itemId === constants.DEFAULT_GROUP_ID){
                        let viewNotificationSectionModel = this.model.get('notificationSections').sections[1];
                        nodes.forEach((node)=>{
                            if(node.hasChildren){
                                viewNotificationSectionModel.groups.push(node);
                            }
                            else{
                                viewNotificationSectionModel.nodes.push(node);
                            }
                        });
                        //dataTarget = ev.currentTarget.children[1].attributes['data-target'].value;
                        if(ev.currentTarget.children.length > 1) {
                            dataTarget = ev.currentTarget.children[1].attributes['data-target'].value;
                        }
                        else{
                            dataTarget = ev.currentTarget.attributes['data-target'].value;
                        }
                        var group={
                            nodes:nodes
                        };
                        this.addItemsToSection(group, dataTarget);
                    }
                    else{
                        let group = this.replaceGroupItemsInModel('notificationSections', 'No Attention Needed', itemId, nodes);
                        this.addItemsToGroup(group, dataTarget);
                    }
                    ev.stopPropagation();

                }).then(()=>{
                    this.handleSection(ev);
                }).catch((error) => {
                    console.log(error);
                    let errorMsg = error.CODE === '2' ? 'User not authenticated:': error.MESSAGE;
                    var msg = errorMsg || 'Unknown Error';
                    NotificationService.error(msg);
                })
            };

            const getFailedNotifications = () =>{
                this.renderFailedNotificationDashboard(ev)
            };

            const map = {'attentionNeeded': getNotifications, 'noAttentionNeeded':getNotifications,'failedNotifications':getFailedNotifications,'none': _none};
            (map[nodeType])();
        }
        else{
            if(ev && nodeType!=='failedNotifications') {
                //let dataTarget = ev.currentTarget.attributes['data-target'].value;
                //$('[data-target="'+ dataTarget + '"] i').toggleClass('pf-carot-left pf-carot-down');
                $('.document').removeClass('active');
                $(ev.currentTarget).parent().addClass('active');
                this.collapseWithoutPropagation(ev);
                nodeType === "attentionNeeded" ? this.renderAttentionNotificationDashboard(ev,true):this.renderAttentionNotificationDashboard();
            }
            else{
                listService.avoidDoubleClickOnDashboardTree = false;
            }
        }
    }

    renderAttentionNotificationDashboard(ev, isAttentionNeeded = false, searchValues){
        this.killDetailView();

        util.disableReloadLink();
        RestService.getDashboardNotifications().then((notificationData)=> {

            // PF-5273 get show hidden value
            let showHiddenName = isAttentionNeeded ? '_showHiddenNotifications_A' : '_showHiddenNotifications_NA';
            let showHiddenNotifications = searchValues ? searchValues.showHidden : listService.userSettings.get(showHiddenName);
            util.enableReloadLink();
            let dashboardNotificationsModel = new DashboardNotificationsModel();


            if (notificationData.NotificationList) {
                let notifications = notificationData.NotificationList.Notification instanceof Array
                    ? notificationData.NotificationList.Notification
                    : [notificationData.NotificationList.Notification];

                dashboardNotificationsModel.set('gridData', notifications, {silent: true});
                dashboardNotificationsModel.set('showHidden', showHiddenNotifications, {silent: true});
                dashboardNotificationsModel.set('form', searchValues ? searchValues.form : 'any' , {silent: true});
                dashboardNotificationsModel.set('title', searchValues  ? searchValues.title : '', {silent: true});
                if(isAttentionNeeded){
                    dashboardNotificationsModel.set('isAttentionNeeded', isAttentionNeeded, {silent: true});
                    dashboardNotificationsModel.set('attentionLevel',searchValues ? searchValues.attentionLevel :constants.NORMAL_PLUS_ATTENTION_LEVEL,{silent:true});
                }
                else{
                    dashboardNotificationsModel.set('isAttentionNeeded', isAttentionNeeded, {silent: true});
                    dashboardNotificationsModel.set('attentionLevel',searchValues ? searchValues.attentionLevel :constants.NONE_ATTENTION_LEVEL,{silent:true});
                }
                dashboardNotificationsModel.set('filteredGridData', Object.assign([],notifications),{silent:true});
            }
            else {
                dashboardNotificationsModel.set('gridData', [], {silent: true});
                dashboardNotificationsModel.set('filteredGridData', [], {silent: true});
                dashboardNotificationsModel.set('title', searchValues  ? searchValues.title : '', {silent: true});
                dashboardNotificationsModel.set('showHidden', searchValues  ? searchValues.showHidden : '', {silent: true});
                dashboardNotificationsModel.set('form', searchValues ? searchValues.form : 'any' , {silent: true});
            }

            let attention = isAttentionNeeded ===  true  ? 'Attention Needed' 
                                                    : 'No Attention Needed'; 

            const breadcrumbs = [
                {name: 'Notifications', route: '#notifications', id: 'goToNotifications'},
               {name: attention, id: 'goToNotification'}
            ];
 
            const dashboardTitle = isAttentionNeeded ? 'Notifications - Attention Needed' : 'Notifications - No Attention Needed';
            dashboardNotificationsModel.set('dashboardTitle', dashboardTitle);
            dashboardNotificationsModel.set('breadcrumbs', breadcrumbs);

            this.detailView = new NotificationsAttentionView({
                model: dashboardNotificationsModel,
                el: constants.DASHBOARD_MAIN_PANEL
            });
            this.detailView.render();
            listService.avoidDoubleClickOnDashboardTree = false;
        }).then(()=>{
            if(ev) {
                super.handleSection(ev);
            }
        }).catch((err=>{
            util.enableReloadLink();
            console.log('Error Rendering Notification Dashboard:',err);
            NotificationService.error('Error Rendering Notification Dashboard'+err.MESSAGE);
        }));
    }

    renderFailedNotificationDashboard(ev){
        this.killDetailView();

        util.disableReloadLink();
        RestService.getDashboardNotifications(true).then((notificationData)=> {
            util.enableReloadLink();
            let dashboardNotificationsModel = new DashboardNotificationsModel();
            if (notificationData.NotificationList) {
                let notifications = notificationData.NotificationList.Notification instanceof Array
                    ? notificationData.NotificationList.Notification
                    : [notificationData.NotificationList.Notification];
                dashboardNotificationsModel.set('gridData', notifications, {silent: true});
                dashboardNotificationsModel.set('filteredGridData', Object.assign([],notifications),{silent:true});
            }
            else {
                dashboardNotificationsModel.set('gridData', [], {silent: true});
                dashboardNotificationsModel.set('filteredGridData', [], {silent: true});
            }

            const breadcrumbs = [
                 {name: 'Notifications', route: '#notifications', id: 'goToNotifications'},
                    {name: 'Failed Notification'}
            ];

            dashboardNotificationsModel.set('dashboardTitle', 'Notifications - Failed Notifications');
            dashboardNotificationsModel.set('breadcrumbs', breadcrumbs);

            this.detailView = new NotificationsFailedView({
                model: dashboardNotificationsModel,
                el: constants.DASHBOARD_MAIN_PANEL
            });
            this.detailView.render();
            listService.avoidDoubleClickOnDashboardTree = false;
          }).then(()=>{
            if(ev && typeof ev !== 'string') {
                super.handleSection(ev);
            }
        }).catch((err=>{
          util.enableReloadLink();
          console.log('Error Rendering Notification Dashboard:',err);
          NotificationService.error('Error Rendering Notification Dashboard'+err.MESSAGE);
        }));
    }

    // Override Base for Specific Handling
    handleSection(ev) {
        ev.stopPropagation();
        let sectionType=$(ev.currentTarget).attr('data-nodeType');
        console.log("Section Type",sectionType);
        super.handleSection(ev);
        const _none = () => {
            ev.stopPropagation();
        };

        const _attentionNeededDashboard = () => {
            this.renderAttentionNotificationDashboard(ev,true);
        };

        const _noAttentionNeededDashboard = () => {
            this.renderAttentionNotificationDashboard(ev,false);
        };

      const _failedNotificationDashboard = () => {
        this.renderFailedNotificationDashboard(ev);
      };

        const map = {'attentionNeeded': _attentionNeededDashboard, 'noAttentionNeeded': _noAttentionNeededDashboard,'failedNotifications': _failedNotificationDashboard};
        (map[sectionType])();
    }

    handleSelectedGroup(ev) {
        var sectionType = ev.currentTarget.attributes['data-nodeType'].value;
        var id = ev.currentTarget.attributes['data-groupid'].value;

        if (sectionType === constants.ATTENTION_NEEDED_SECTION || sectionType === constants.NO_ATTENTION_NEEDED_SECTION) {
            var groupTypeId = id;

            // if classname of children[1] contains 'collapsed' then ignore , only load on expand.
            if (new RegExp('collapsed').test(ev.currentTarget.children[1].className)) {
                var dataTarget = ev.currentTarget.children[1].attributes['data-target'].value;
                $('[data-target="'+ dataTarget + '"]').toggleClass('pf-carot-left pf-carot-down');

                RestService.getNotifications(groupType === 'attentionNeeded').then((data) => {
                    let notifications = data.NotificationList.Notification instanceof  Array?
                        data.NotificationList.Notification : [data.NotificationList.Notification];

                    if (notifications) {
                        var nodes = this.loadNodesFromResponse(notifications, groupTypeId);

                        // Update Model So It Will Be There Later, duh.
                        var group = this.replaceGroupItemsInModel('notificationSections', 'Attention Needed', groupTypeId, nodes);
                        this.addItemsToGroup(group, dataTarget);
                    }

                }).catch((error) => {
                    console.log(error);
                    let errorMsg = error.CODE === '2' ? 'User not authenticated:': error.MESSAGE;
                    var msg = errorMsg || 'Unknown Error';
                    NotificationService.error(msg);
                });
            }else{
                this.collapseWithoutPropagation(ev);
            }
        }
    }

    handleSelectedGroupItem(ev) {
        try {
            ev.preventDefault();
        } catch (e) {
            console.log("error", e);
        }

        let itemId = ev.currentTarget.attributes['data-itemid'].value;
        let groupType = ev.currentTarget.attributes['data-groupType'].value;
        let nodeType = ev.currentTarget.attributes['data-nodeType'].value;
        let notificationName = $(ev.currentTarget).text();
        console.log("Items Selected", itemId, groupType, nodeType, notificationName);
        this.removeItemGroupSelection();
        this.addItemGroupSelection(ev.currentTarget);

        const _attn = () => {
            this.killDetailView();

            let notificationId = itemId.substr(itemId.indexOf('_') + 1);
            this.renderNotificationDetails(notificationId, groupType, itemId);
        };

        const map = {
            'attentionNeeded': _attn,
            'noAttentionNeeded': _attn
        };

        const fn = map[nodeType];
        if (fn) {
            (fn)();
        }

        this.activateSection(ev);
    }

    renderNotificationDetails(notificationId, groupType, itemId) {
        this.killDetailView();
        
        util.disableReloadLink();
        RestService.getNotificationDetails(notificationId).then((notificationData)=> {
            util.enableReloadLink();
            let attention = groupType === 'noAttentionNeeded' ? 'No Attention Needed'
                                                    : 'Attention Needed';
        
            let notificationDetailsModel = new NotificationDetailsModel();

            var breadcrumbs = [
               {name: 'Notifications', route: '#notifications', id: 'goToNotifications'},
               {name: attention, id: 'goToNotification'},
               {name: 'Notification Details'}
            ];

            notificationDetailsModel.set('dashboardTitle', 'Notification - '+ notificationData.Name);
            notificationDetailsModel.set('breadcrumbs', breadcrumbs);
            notificationDetailsModel.set('notificationDetails', notificationData);
            notificationDetailsModel.set('groupType', groupType);
            this.detailView = new NotificationDetailsView({
                model: notificationDetailsModel,
                el: constants.DASHBOARD_MAIN_PANEL
            });
            
            this.detailView.render();
        }).catch((error) => {
            util.enableReloadLink();
            console.log(error);
            let errorMsg = error.CODE === '2' ? 'User not authenticated:' : error.MESSAGE;
            var msg = errorMsg || 'Unknown Error';
            NotificationService.error(msg);
        });
    }

    loadNodesFromResponse(notifications, groupType) {

        let nodes = [];
        let itemNodeType = '';
        let groupResponseType='';
        // PF-5273
        let showHiddenNotifications = '';

        if (groupType === constants.NOTIFICATION_ATTENTION_NEEDED_GROUP_TYPE || groupType === constants.NOTIFICATION_NO_ATTENTION_NEEDED_GROUP_TYPE) {
            itemNodeType = 'group';
            groupResponseType=groupType;
            showHiddenNotifications = groupTypelistService.userSettings.get('_showHiddenNotifications_A'); // Attention needed
        }
        else {
            itemNodeType = 'noAttentionNeeded';
            groupResponseType=itemNodeType;
            showHiddenNotifications = listService.userSettings.get('_showHiddenNotifications_NA'); //  No attention needed
        }


        let nodeDate;
        let notificationsOrderedByDate=_.sortBy(notifications,(notification)=>{
           return new Moment(notification['@NotificationDate']);
        }).reverse();

        for (let n of notificationsOrderedByDate) {
            if (!showHiddenNotifications && n['@IsHidden']== 'True') {
                continue;
            }
            nodeDate = new Date(n['@NotificationDate'] + " GMT").toLocaleDateString('en-GB', {
                day : 'numeric',
                month : 'short',
                year : 'numeric'
            }).split(' ').join('-');
            nodes.push(
                {
                    nodeName: n['@Name'] + ' (' + nodeDate + ')',
                    attentionLevel: n['@AttentionLevel'],
                    url: '#',
                    icon: 'fa fa-envelope',
                    id: groupType + '_' + n['@NotificationId'],
                    groupType: groupType,
                    nodeType: groupType,
                    toggleIcon: '',
                    hasChildren: false,
                    iconColor: util.getAttentionLevelColor(n['@AttentionLevel'])
                });
        }
        return nodes;
    }

    renderNotificationDashboardAndNodes(itemId,dataTarget,groupType) {
        util.cleanChildNodes(dataTarget);
        util.cleanSelectedNodeOnDashboard();
        util.disableReloadLink();
        RestService.getNotifications(groupType === 'attentionNeeded').then((data) => {
            util.enableReloadLink();
            let notifications;
            if (data.NotificationList) {
                notifications = data.NotificationList.Notification instanceof Array ?
                    data.NotificationList.Notification : [data.NotificationList.Notification];
            }

            let nodes = [];
            if (notifications) {
                nodes = this.loadNodesFromResponse(notifications, groupType);
            } else {
                nodes = [{
                    nodeName: 'no items',
                    url: '#',
                    icon: ICON_EMPTY,
                    id: 0,
                    groupType: groupType,
                    nodeType: '',
                    hasChildren: false
                }]
            }
                let viewNotificationSectionModel=this.model.get('notificationSections').sections[1];
                nodes.forEach((node)=>{
                    if(node.hasChildren){
                        viewNotificationSectionModel.groups.push(node);
                    }
                    else{
                        viewNotificationSectionModel.nodes.push(node);
                    }
                });
                let group={
                    nodes:nodes
                };
                this.addItemsToSection(group, dataTarget);

            this.renderAttentionNotificationDashboard(null,groupType === 'attentionNeeded',null)
        }).catch((error) => {
            util.enableReloadLink();
            console.log(error);
            let errorMsg = error.CODE === '2' ? 'User not authenticated:' : error.MESSAGE;
            var msg = errorMsg || 'Unknown Error';
            NotificationService.error(msg);
        });
    }

    refreshNotificationsMainView(){
        const requestParamsObject = {
            includeNotifications: 'true',
            notificationsFromAttentionLevel: '1',
            notificationsToAttentionLevel: '5'
        };
        let dashboardNotificationsModel = new DashboardNotificationsModel();

        RestService.getDashboardDetails(requestParamsObject).then((data)=> {
            let notificationList = [];
            const respNotificationList = data.RESULT.RESPONSE.NotificationList;
            if (respNotificationList && respNotificationList.Notification) {
                notificationList = data.RESULT.RESPONSE.NotificationList.Notification instanceof Array
                    ? data.RESULT.RESPONSE.NotificationList.Notification
                    : [data.RESULT.RESPONSE.NotificationList.Notification];
            }
            dashboardNotificationsModel.set('notificationList', notificationList);

            let notificationDetailsView=new NotificationMainView({model: dashboardNotificationsModel, el: constants.DASHBOARD_MAIN_PANEL});
            listService.dashboardLayout.mainPanelView=notificationDetailsView;
            this.detailView = notificationDetailsView;
            this.detailView.render();
        }).catch((error) => {
            console.log(error);
            var msg = error || 'Error on Retrieving Notifications Dashboard Data';
            NotificationService.error(msg);
        });
    }



    render() {
        super.render();
        //Default view comes from the Dashboard View.
    }  
}

export default NotificationsLeftPanelView;